const LOGIN_REDIRECT_QUERY_KEY = 'redirect';

/**
 * Builds the login-route query payload used to preserve an intended in-app
 * destination during auth redirects.
 *
 * The router stores only internal full paths so a refreshed login page can
 * still return the user to the same protected view after authentication.
 *
 * @param {import('vue-router').RouteLocationNormalized} to
 * @returns {{ redirect?: string }}
 */
export function buildLoginRedirectQuery(to) {
  const redirect = sanitizeInternalRedirect(to?.fullPath);

  if (!redirect) {
    return {};
  }

  return {
    [LOGIN_REDIRECT_QUERY_KEY]: redirect
  };
}

/**
 * Resolves the safe post-login destination from a route query value.
 *
 * Query parameters can be tampered with manually, so login should only honor
 * in-app absolute paths and ignore anything that looks external or malformed.
 *
 * @param {unknown} redirectCandidate
 * @returns {string | null}
 */
export function resolveSafeRedirect(redirectCandidate) {
  if (Array.isArray(redirectCandidate)) {
    return sanitizeInternalRedirect(redirectCandidate[0]);
  }

  return sanitizeInternalRedirect(redirectCandidate);
}

function sanitizeInternalRedirect(redirectCandidate) {
  if (typeof redirectCandidate !== 'string' || redirectCandidate.length === 0) {
    return null;
  }

  if (
    !redirectCandidate.startsWith('/') ||
    redirectCandidate.startsWith('//')
  ) {
    return null;
  }

  return redirectCandidate;
}
